import BBTab from './Tab'
import BBTabList from './TabList'
import BBTabPanel from './TabPanel'
import BBTabs from './Tabs'

export { BBTabList, BBTabs, BBTab, BBTabPanel }
